import React, { useEffect, useState } from 'react'
import NangoIntegration from '../../Settings/components/integration/Nango'
import IntegrationTopbar from '../Auth/Components/Topbar'
import IntegrationCard from './Components/IntegrationCard'
import axios from 'axios'
import { useUserInfo } from '../../../context/user'
import env from '../../../config/env'

const IntegrationsApp = () => {
    const [integration, setIntegrations] = useState([])
    const userActiveLocation = useUserInfo()[4]
    const getIntegrations = async () => {
        const response = await axios.get(env.API_URL + "/v1/integrations/available-branding?agency_id=" + userActiveLocation?.agency_id)
        if (response?.data?.success) {
            setIntegrations(response?.data?.data || []);
        }
    }

    useEffect(() => {
        if (userActiveLocation?.agency_id)
            getIntegrations()
    }, [userActiveLocation])


    return (
        <div className=''>
            <IntegrationTopbar />
            <div className='mt-10 !mx-20'>
                <p className='text-2xl font-bold mb-8'>Integrations</p>
                <div className='flex flex-wrap'>
                    {userActiveLocation?.active_integrations?.length > 0 ? integration?.filter((integration) => userActiveLocation?.active_integrations?.includes(integration.provider)).map((integration) => <IntegrationCard key={integration.provider} integration={integration} />) : <><p>No integration enabled for this account</p></>}
                </div>
            </div>
        </div>
    )
}

export default IntegrationsApp